---
title: Patterns
---
